<!-- _Generated with AI_ -->

<script setup lang="ts">
import { ref } from 'vue';
import QuoteForm from '~components/QuoteForm.vue';

withDefaults(defineProps<{
  product: 'school' | 'homeschool' | 'district';
  btnClass?: string;
  btnLabel?: string;
}>(), {
  btnClass: 'btn-success',
  btnLabel: 'Get a Quote',
});

const showDialog = ref(false);
</script>

<template>
  <div>
    <button class="btn btn-block btn-lg" :class="btnClass" style="font-size: 18px" @click="showDialog = true">
      {{ btnLabel }}
    </button>

    <b-modal v-model="showDialog" title="Request a Quote" ref="modal" hide-footer>
      <QuoteForm :product="product" @submitted="showDialog = false" />
    </b-modal>
  </div>
</template>
